(function () {
  "use strict";

  EditCoursesAndSeriesSidebarCtrl.$inject = ['$scope', 'usersResource', 'mtypes', '$timeout', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('EditCoursesAndSeriesSidebarCtrl', EditCoursesAndSeriesSidebarCtrl);

  function EditCoursesAndSeriesSidebarCtrl($scope, usersResource, mtypes, $timeout, trainerPrivilege) {
    $scope.multiEditMode = false;
    $scope.recentlyAddedCourse = null;

    var recentlyAddedCourseTimerPromise = null;
    var types = {};
    var userRole = trainerPrivilege.roles();

    setupSelector('course');
    if ($scope.hasSeriesFeature)
      setupSelector('series');

    function setupSelector(type) {
      var typeObj = types[type] = {};
      typeObj.plural = type;
      if (type != 'series')
        typeObj.plural = type + 's';
      typeObj.pluralCap = typeObj.plural.charAt(0).toUpperCase() + typeObj.plural.slice(1);
      typeObj.availableSelectItems = [];
      typeObj.idsToInviteTo = [];

      $scope['select' + typeObj.pluralCap + 'Options'] = {
        width: '100%',
        placeholder: 'Add ' + typeObj.plural + '...',
        multiple: true,
        query: query,
        data: $scope['all' + typeObj.pluralCap],
        allowClear: true,
        dropdownCssClass: 'select2-dropdown-size-hack'
      };

      function query(query) {
        var data = {results:getAllResults(query.term, query.element)};
        query.callback(data);
      }

      function getAllResults(term, elem) {
        if (!term || term.length == 0)
          return typeObj.availableSelectItems;

        var termLower = term.toLowerCase();

        var result =  _.filter(typeObj.availableSelectItems, function (item) {
          return item.text.toLowerCase().indexOf(termLower) >= 0;
        });

        return result;
      }
    }

    function refreshAvailableSelectItems(type) {
      var typeObj = types[type];
      $scope[typeObj.plural] = $scope['user' + typeObj.pluralCap + 'InEdit'];
      typeObj.idsNotAvailableForSelection = {};
      $scope['stored' + typeObj.pluralCap] = [];
      _.each($scope[typeObj.plural], function (c) {
        var fullData = $scope[type + 'Lookup'][c.id];
        if (c.count === 'All')
          typeObj.idsNotAvailableForSelection[c.id] = true;
        c.locked = true;
        c.isArchived = (fullData && fullData.status == mtypes.courseStatus.archive);
        $scope['stored' + typeObj.pluralCap].push(_.clone(c));
      });

      typeObj.availableSelectItems = _.chain($scope['all' + typeObj.pluralCap])
        .reject(function (c) {
          var reject = typeObj.idsNotAvailableForSelection[c.id] || c.status == mtypes.courseStatus.archive ||
            (!userRole.canViewDraftCourses && c.status == mtypes.courseStatus.draft);
          if (type == 'series')
            reject = reject || c.numCourses == 0;
          return reject;
        })
        .map(function (c) {
          return {
            id: c.id,
            text: c.name
          };
        })
        .value();
    }

    function refreshAvailableCourseAndSeriesSelectItems() {
      refreshAvailableSelectItems('course');
      if ($scope.hasSeriesFeature)
        refreshAvailableSelectItems('series');
    }

    $scope.$on('refreshAvailableCourseAndSeriesSelectItems', function () {
      refreshAvailableCourseAndSeriesSelectItems();
    });

    refreshAvailableCourseAndSeriesSelectItems();

    function exit() {
      clean();
      $scope.openDetailsSidebar();
    }

    $scope.cancelChanges = function () {
      exit();
    };

    $scope.canApplyChanges = function () {
      return $scope.manageUsersEditors.coursesAndSeriesEditor && !$scope.serverCallInProgress;
    };

    $scope.addCourse = function (course, type) {
      $scope.applyToAll(course.id, type);

      $scope.recentlyAddedCourse = course;
      if (recentlyAddedCourseTimerPromise) {
        $timeout.cancel(recentlyAddedCourseTimerPromise);
        recentlyAddedCourseTimerPromise = null;
      }
      recentlyAddedCourseTimerPromise = $timeout(function () {
        $scope.recentlyAddedCourse = null;
        recentlyAddedCourseTimerPromise = null;
      }, 5000);
    };

    $scope.applyToAll = function (courseId, type) {
      var typeObj = types[type];
      var course = _.find($scope[typeObj.plural], function (c) {
        return c.id == courseId;
      });

      if (!course) {
        course = {id:courseId, name:$scope[type + 'Lookup'][courseId].name};
        $scope[typeObj.plural].push(course);
      }

      course.count = 'All';
      course.locked = false;

      typeObj.availableSelectItems = _.reject(typeObj.availableSelectItems, function (item) {
        return item.id == courseId;
      });

      typeObj.idsToInviteTo.push(course.id);
      updateDirtyFlag();
    };

    $scope.remove = function (courseId, type) {
      var typeObj = types[type];
      var storedCourse = _.find($scope['stored' + typeObj.pluralCap], function (c) {
        return c.id == courseId;
      });

      var courseIndex = null;
      _.each($scope[typeObj.plural], function (course, index) {
        if (course.id == courseId) {
          courseIndex = index;
          if (course.count == 'All') {
            typeObj.availableSelectItems.push({
              id:course.id,
              text:course.name
            });
          }
        }
      });

      if (storedCourse)
        $scope[typeObj.plural][courseIndex] = _.clone(storedCourse);
      else
        $scope[typeObj.plural].splice(courseIndex, 1);

      typeObj.idsToInviteTo = _.reject(typeObj.idsToInviteTo, function (id) {
        return courseId == id;
      });

      updateDirtyFlag();
      if ($scope.forceCloseDropDown)
        $scope.forceCloseDropDown();
    };

    function updateDirtyFlag() {
      var isDirty = false;
      _.each(types, function (typeObj) {
        if (typeObj.idsToInviteTo.length > 0)
          isDirty = true;
      });
      $scope.manageUsersEditors.coursesAndSeriesEditor = isDirty;
    }

    function clean() {
      types = {};
      $scope.manageUsersEditors.coursesAndSeriesEditor = false;
      $scope.serverCallInProgress = false;
      $scope.hideSpinner();
    }

    $scope.applyChanges = function () {
      var date = new Date();
      var clientDatestamp = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var userIds = _.pluck($scope.storedSelectedUsers, 'id');

      var saveData = {
        traineeIds: userIds,
        courseIds: types['course'].idsToInviteTo,
        clientDatestamp: clientDatestamp
      };

      if (types['series'])
        saveData.seriesIds = types['series'].idsToInviteTo;

      $scope.serverCallInProgress = true;
      $scope.showSpinner();
      usersResource.inviteUsersToCoursesAndSeries(saveData, function (res) {
        $scope.manageUsersEditors.coursesAndSeriesEditor = false;
        $scope.refreshSelectedUserInfo(function () {
          $scope.serverCallInProgress = false;
          clean();
          exit();
        });
      });
    };

    $scope.$watch('selectedUsers', function () {
      if ($scope.selectedUsers) {
        $scope.storedSelectedUsers = $scope.selectedUsers.slice();
        $scope.headerText = $scope.storedSelectedUsers.length + " users selected";
        $timeout(function () {
          $scope.multiEditMode = true;
        });
      }
    });
    $scope.$watch('selectedUser', function () {
      if ($scope.selectedUser) {
        $scope.storedSelectedUsers = [$scope.selectedUser];
        $scope.headerText = '1 user selected';
        $timeout(function () {
          $scope.multiEditMode = false;
        });
      }
    });
  }

})();
